// Analytics using Umami v2
// Umami script is loaded in index.html

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, any>) => void
    }
  }
}

export const Analytics = {
  track(event: string, data?: Record<string, string | number | boolean>) {
    if (typeof window !== 'undefined') {
      if (window.umami?.track) {
        window.umami.track(event, data)
        if (import.meta.env.DEV) {
          console.log('[Analytics - Sent]', event, data)
        }
      } else {
        if (import.meta.env.DEV) {
          console.log('[Analytics - Not Ready]', event, data)
          console.log('window.umami:', window.umami)
        }
      }
    }
  },

  gameStart() {
    this.track('game_start', {
      returning: localStorage.getItem('gpt-clicker-save') !== null
    })
  },

  milestone(name: string, playTime: number) {
    this.track('milestone', {
      name,
      play_time: Math.floor(playTime)
    })
  },

  share(platform: string, stats: { playTime: number; money: number; users: number; models: number }) {
    this.track('share', {
      platform,
      play_time: Math.floor(stats.playTime),
      money: Math.floor(stats.money),
      users: Math.floor(stats.users),
      models: stats.models
    })
  },

  modelUnlocked(modelId: string, playTime: number) {
    this.track('model_unlocked', {
      model: modelId,
      play_time: Math.floor(playTime)
    })
  },

  hardwarePurchased(hardwareId: string, playTime: number) {
    this.track('hardware_purchased', {
      hardware: hardwareId,
      play_time: Math.floor(playTime)
    })
  }
}
